import React, { useEffect, useState } from 'react';
import { WebContainer } from '@webcontainer/api';
import { WebContainerContext } from '../contexts/WebContainerContext';

const WebContainerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [webContainer, setWebContainer] = useState<WebContainer | null>(null);
  const [iframeSrc, setIframeSrc] = useState<string>('');

  useEffect(() => {
    const initWebContainer = async () => {
      if (webContainer) {
        return;
      }
      const container = await WebContainer.boot({ workdirName: 'project' });
      container.on('error', error => {
        console.error('WebContainer error:', error);
      });
      container.on('port', (port, type, url) => {
        if (type === 'close') {
          setIframeSrc('');
          console.log('port closed');
        } else if (type === 'open') {
          console.log(`Server running on ${url}`);
          setIframeSrc(url);
        }
      });
      setWebContainer(container);
    };
    initWebContainer();
  }, []);

  return <WebContainerContext.Provider value={{ webContainer, iframeSrc }}>{children}</WebContainerContext.Provider>;
};

export default WebContainerProvider;
